import React from 'react';
import { Box, Card, CardContent, Stack, Typography, Checkbox, TextField } from '@mui/material';

const ReservationDataForm = ({ formik }) => (
  <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Box display="flex" flexDirection="column" justifyContent="space-between" mt={1} width="100%">
      <Card>
        <CardContent>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
              <Checkbox id="health_statement" name="health_statement" checked={formik.values.health_statement} onChange={formik.handleChange}/>
              <Typography variant="subtitle2">Zapoznanie się z oświadczeniem o stanie zdrowia</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
              <Checkbox id="health_statement_delivered" name="health_statement_delivered" checked={formik.values.health_statement_delivered} onChange={formik.handleChange}/>
              <Typography variant="subtitle2">Dostarczono oświadczenie o stanie zdrowia</Typography>
            </Stack>
            <Box sx={{ flex: '1 1 50%' }} />
          </Stack>
          <Box height={20}/>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
              <Checkbox id="payment_regulations" name="payment_regulations" checked={formik.values.payment_regulations} onChange={formik.handleChange} />
              <Typography variant="subtitle2">Zapoznanie się z regulaminem płatności</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
              <Checkbox id="payment_regulations_delivered" name="payment_regulations_delivered" checked={formik.values.payment_regulations_delivered} onChange={formik.handleChange} />
              <Typography variant="subtitle2">Dostarczono regulamin płatności</Typography>
            </Stack>
            <Box sx={{ flex: '1 1 50%' }} />
          </Stack>
          <Box height={20}/>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
              <Checkbox id="personal_survey" name="personal_survey" checked={formik.values.personal_survey} onChange={formik.handleChange} />
              <Typography variant="subtitle2">Zapoznanie się z ankietą osobową</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
              <Checkbox id="personal_survey_delivered" name="personal_survey_delivered" checked={formik.values.personal_survey_delivered} onChange={formik.handleChange} />
              <Typography variant="subtitle2">Dostarczono ankiete osobową</Typography>
            </Stack>
            <Box sx={{ flex: '1 1 50%' }} />
          </Stack>
          <Box height={20}/>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 25%">
              <Checkbox id="insurance_and_personal_data" name="insurance_and_personal_data" checked={formik.values.insurance_and_personal_data} onChange={formik.handleChange} />
              <Typography variant="subtitle2">Ubezpieczenie i przetwarzanie danych osobowych</Typography>
            </Stack>
            <Box sx={{ flex: '1 1 75%' }} />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  </form>
);


export default ReservationDataForm;
